<template>
    <d-dropdown :text="label" :theme="theme" right split @click.prevent="handleClick">
        <CDropdownItem 
            v-for="(item,index) in items"
            :key="index"
            :label="item.label"
            :id="item.id"
            @picked="handleItemSelect"
        />
    </d-dropdown>
</template>
<script>
import CDropdownItem from '@/components/contracts/conditions/atoms/CDropdownItem';
import { mapGetters } from 'vuex'

export default {
    props: {
        label: String,
        theme: String
    },
    components: { CDropdownItem },
    computed: {
        ...mapGetters({
            items: 'getAllBasicConditions'
        })
    },
    methods: {
        handleClick(){
            this.$emit('select-new')
        },
        handleItemSelect({ id, date }){
            this.$emit('select-basic', {id, date})
        }
    }
}
</script>